// export const genderFilter = {
//   filterName: "Gender",
//   filterType: "radio",
//   property: "gender",
//   selectedCount: 0,
//   filters: [
//     {
//       id: 1,
//       checked: true,
//       label: "Male",
//     },
//     {
//       id: 2,
//       checked: false,
//       label: "Female",
//     },
//   ],
// };

import {
	annualIncomeOptions,
	casteOptions,
	countryOptions,
	drinkingHabitsOptions,
	foodHabitsOptions,
	gotraOptions,
	maritalStatusOptions,
	motherTongueOptions,
	nakshatraOptions,
	occupationOptions,
	qualificationOptions,
	rashiHindiOptions,
	smokingHabitsOptions,
	stateOptions,
} from './profileData';

export const maritalStatusFilter = () => {
	return {
		filterName: 'Marital Status',
		filterType: 'checkbox',
		property: 'maritalStatus',
		backendProperty: 'maritial_status',
		selectedCount: maritalStatusOptions.length,
		enableSelectAll: true,
		filters: maritalStatusOptions.map((option, index) => {
			return {
				id: index,
				checked: true,
				label: option.label,
				value: option.value,
			};
		}),
	}
}

export const occupationFilter = () => {
	return {
	filterName: 'Occupation',
	filterType: 'checkbox',
	property: 'occupation',
	backendProperty: 'occupation',
	selectedCount: occupationOptions.length,
	enableSelectAll: true,
	filters: occupationOptions.map((option, index) => {
		return {
			id: index,
			checked: true,
			label: option.label,
            value: option.value,
		};
	}),
};
} 


export const annualIncomeFilter = () => {
	return {
		filterName: 'Annual Income',
		filterType: 'checkbox',
		property: 'annualIncome',
		backendProperty: 'annual_income',
		selectedCount: annualIncomeOptions.length,
		enableSelectAll: true,
		filters: annualIncomeOptions.map((option, index) => {
			return {
				id: index,
				checked: true,
				label: option.label,
				value: option.value,
			};
		}),
	};
}

export const religionFilter = {
	filterName: 'Religion',
	filterType: 'checkbox',
	property: 'religion',
	selectedCount: 0,
	filters: [
		{
			id: 1,
			checked: true,
			label: 'Hindu',
		},
		{
			id: 2,
			checked: false,
			label: 'Muslim',
		},
		{
			id: 3,
			checked: false,
			label: 'Sikh',
		},
		{
			id: 4,
			checked: false,
			label: 'Christian',
		},
		{
			id: 5,
			checked: false,
			label: 'Jain',
		},
		{
			id: 6,
			checked: false,
			label: 'Parsi',
		},
		{
			id: 7,
			checked: false,
			label: 'Buddhist',
		},
		{
			id: 8,
			checked: false,
			label: 'Other',
		},
	],
};

export const motherTongueFilter = () => {
	return {
		filterName: 'Mother Tongue',
		filterType: 'checkbox',
		property: 'motherTongue',
		selectedCount: motherTongueOptions().length,
		enableSelectAll: true,
		backendProperty: 'mother_tongue',
		filters: motherTongueOptions().map((option, index) => {
			return {
				id: index,
				checked: true,
				label: option.label,
				value: option.value,
			};
		}),
	};
}
export const qualificationFilter = () => {
	return {
		filterName: 'Qualification',
		filterType: 'checkbox',
		property: 'qualification',
		backendProperty: 'qualifications',
		selectedCount: qualificationOptions.length,
		enableSelectAll: true,
		filters: qualificationOptions.map((option, index) => {
			return {
				id: index,
				checked: true,
				label: option,
				value: option,
			};
		}),
	};
}
export const casteFilter= () => {
	return {
		filterName: 'Caste',
		filterType: 'checkbox',
		property: 'caste',
		selectedCount: casteOptions.length,
		enableSelectAll: true,
		backendProperty: 'caste',
		filters: casteOptions.map((option, index) => {
			return {
				id: index,
				checked: true,
				label: option.label,
				value: option.value,
			};
		}),
	};
}

export const rashiFilter = () => {
	return {
		filterName: 'Rashi',
		filterType: 'checkbox',
		property: 'rashi',
		selectedCount: rashiHindiOptions.length,
		enableSelectAll: true,
		backendProperty: 'rashi',
		filters: rashiHindiOptions.map((option, index) => {
			return {
				id: index,
				checked: true,
				label: option.label,
				value: option.value,
			};
		}),
	};
}
export const nakshatraFilter = () => {
	return {
		filterName: 'Nakshatra ',
		filterType: 'checkbox',
		property: 'nakshatra',
		selectedCount: nakshatraOptions.length,
		enableSelectAll: true,
		backendProperty: 'nakshatra',
		filters: nakshatraOptions.map((option, index) => {
			return {
				id: index,
				checked: true,
				label: option.label,
				value: option.value,
			};
		}),
	};
}
export const foodHabitsFilter = () => {
	return {
		filterName: 'Food Habits',
		filterType: 'checkbox',
		property: 'foodHabits',
		selectedCount: foodHabitsOptions.length,
		backendProperty: 'food_habits',
		enableSelectAll: true,
		filters: foodHabitsOptions.map((option, index) => {
			return {
				id: index,
				checked: true,
				label: option.label,
				value: option.value,
			};
		}),
	};
}

export const drinkingHabitsFilter = () => {
	return {
		filterName: 'Drinking Habits',
		filterType: 'checkbox',
		property: 'drinkingHabits',
		selectedCount: drinkingHabitsOptions.length,
		enableSelectAll: true,
		backendProperty: 'drinking_habits',
		isBinary: false,
		filters: drinkingHabitsOptions.map((option, index) => {
			return {
				id: index,
				checked: true,
				label: option.label,
				value: option.value,
			};
		})
	};
}
export const NRIFilter = () => {
	return {
		filterName: 'NRI',
		filterType: 'checkbox',
		property: 'isNRI',
		selectedCount: 0,
		isBinary: true,
		backendProperty: 'is_nri',
		filters: [
			{
				id: 1,
				checked: false,
				label: 'Yes',
				value: 'Yes'
			},
			{
				id: 2,
				checked: false,
				label: 'No',
				value: 'No'
			},
		],
	};
}

export const smokingHabitsFilter = () => {
	return {
		filterName: 'Smoking Habits',
		filterType: 'checkbox',
		property: 'smokingHabits',
		selectedCount: smokingHabitsOptions.length,
		enableSelectAll: true,
		backendProperty: 'smoking_habits',
		isBinary: false,
		filters: smokingHabitsOptions.map((option, index) => {
			return {
				id: index,
				checked: true,
				label: option.label,
				value: option.value,
			};
		})
	};
}

export const gotraFilter = () => {
	return {
		filterName: 'Gotra',
		filterType: 'checkbox',
		property: 'gotra',
		selectedCount: gotraOptions.length,
		enableSelectAll: true,
		backendProperty: 'gotra',
		isBinary: false,
		filters: gotraOptions.map((option, index) => {
			return {
				id: index,
				checked: true,
				label: option.label,
				value: option.value,
			};
		})
	};
}

export const stateFilter = () => {
	return {
		filterName: 'State',
		filterType: 'checkbox',
		property: 'state',
		selectedCount: stateOptions.length,
		enableSelectAll: true,
		backendProperty: 'state',
		filters: stateOptions.map((option, index) => {
			return {
				id: index,
				checked: true,
				label: option.label,
				value: option.value,
			};
		}),
	};
}

export const countryFilter = () => {
	return {
		filterName: 'Country',
		filterType: 'checkbox',
		property: 'country',
		selectedCount: countryOptions.length,
		enableSelectAll: true,
		backendProperty: 'country',
		filters: countryOptions.map((option, index) => {
			return {
				id: index,
				checked: true,
				label: option.label,
				value: option.value,
			};
		}),
	}
}


export const SELECT_ALL_FILTER = "Select All";
// const filterqual = [ 'BE', 'BCom']; //filter.map((item, index) => {id: index, checked: false, lavbel: item})
